// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XlcAm","delete":"styles_delete__1S16K","update":"styles_update__2XHZk","add":"styles_add__3_5pi"};